import Button, { ButtonProps } from '@mui/material/Button'
import Link, { LinkProps } from 'next/link'
import React from 'react'

/**
 * We need to Omit from the MUI Button the {href} prop
 * as we have to handle routing with Next.js Router
 * so we block the possibility to specify an href.
 */

export type ButtonLinkProps = Omit<ButtonProps, 'href' | 'classes'> &
  Pick<LinkProps, 'href' | 'as' | 'prefetch'>

const ButtonLink = React.forwardRef<ButtonLinkProps, any>(
  ({ href, prefetch, ...props }, ref) => (
    <Link href={href} prefetch={prefetch} passHref={true} legacyBehavior>
      <Button ref={ref} {...props} />
    </Link>
  ),
)

ButtonLink.displayName = 'ButtonLink'

export { ButtonLink }
